export default __webpack_public_path__ + "static/media/people2.5fdef8fb.png";